import { render, RenderResult } from '@testing-library/react';
import React from 'react';
import { Navigate, useRoutes, MemoryRouter } from 'react-router-dom';

import { paths } from '../paths';
import { authRoutes } from './auth';
import { webAppRoutes } from './web-app';
import { errorRoutes } from './error';

export const renderWithRouter = (ui: React.ReactElement): RenderResult =>
  render(
    <MemoryRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      {ui}
    </MemoryRouter>
  );

export default function Router() {
  return useRoutes([
    // SET INDEX PAGE WITH SKIP HOME PAGE
    {
      path: '/',
      element: <Navigate to={paths.webapp.home.root} replace />,
    },

    {
      path: '/webapp/',
      element: <Navigate to={paths.webapp.home.root} replace />,
    },

    { path: '*', element: <Navigate to="/404" replace /> },

    ...authRoutes,

    ...errorRoutes,

    ...webAppRoutes,
  ]);
}
